import { ChromeHeading, Diamond } from "../funnel";

const LINES = [
  "Show up on time. We hold your spot, and we ask the same respect back.",
  "Have your reports open. We'll look at your real file together.",
  "Bring your partner if they're part of the decision.",
];

export const ApplyInfo = () => (
  <div className="fade-up lg:sticky lg:top-10 lg:self-start" data-testid="apply-info">
    <p className="font-mono-plex text-[11px] tracking-[0.2em] text-[var(--gold)] sm:text-[12px] sm:tracking-[0.28em]" data-testid="apply-eyebrow">APPLY · PERSONALIZED STRATEGY CALL</p>
    <ChromeHeading as="h1" className="mt-5 text-[44px] sm:text-6xl lg:text-7xl" data-testid="apply-headline">Let's see if you're a fit</ChromeHeading>
    <p className="mt-6 max-w-xl text-[16px] leading-relaxed text-[#cfc7b6] sm:text-lg" data-testid="apply-intro">Fill this out and book a time. On the call we look at where your credit and business are today and map the path. You don't pay anything on the call.</p>
    <ul className="mt-8 space-y-4 border-l border-[rgba(232,184,74,0.35)] pl-5">
      {LINES.map((l, i) => (
        <li key={l} className="flex items-start gap-3 text-[15px] leading-relaxed text-[#e4dccb]" data-testid={`apply-line-${i + 1}`}>
          <Diamond className="mt-[3px] text-[10px]" />
          <span>{l}</span>
        </li>
      ))}
    </ul>
  </div>
);
